<componenteNavbar/>

<router-outlet/>

<componenteFooter/>